module.exports = __webpack_public_path__ + "static/media/vod27.acad21c3.png";